import { AbstractControl } from '@angular/forms';


export function validateTerms(control: AbstractControl) {
  if (control.value != "1" || !control.value) {
    return { validTerms: true };
  }
  return null;
}